import axios from 'axios';


export default {

	methods: {

		initialize () {
      this.leds = []
      this.cargar = true

      const payload = {
        fechaini: this.fechaini,
        fechafin: this.fechafin,
        escuela:  this.escuela
      }

      return this.$http.post('leds.list/', payload ).then(response=>{
      	this.leds = response.data
      	this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getContactosAsignados ( ){
      const payload = {
        fecha_inicio: this.fecha_inicio,
        fecha_final:  this.fecha_final,
        escuela:      this.escuela
      }
      this.$http.post('data.dashboard.marketing', payload).then((response) => {
        this.contactosVendedora  = response.data.planteles_list
        this.vendedorasDesglose  = response.data.vendedoras
        return
      }).catch(error=>{
        this.cargar = false
      })
    },

    /****************************/
    /****    	 CATALGOS      ****/
    /****************************/
    getComoNosConocio () {
      this.medios_contacto = []
      this.cargar = true
      return this.$http.get('mediocontacto.activas').then(response=>{
      	this.medios_contacto = response.data
      	this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getFuntes () {
      this.cargar = true
      return this.$http.get('fuentes.list').then(response => {
        const data = Array.isArray(response.data) ? response.data : []
        this.fuentes = data.filter(el => !Number(el.deleted))
      }).catch( error =>{
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudieron cargar los orígenes')
      }).finally( () => { this.cargar = false })
    },
    
    getDetallesFuente () {
      this.detalles = []
      this.cargar = true
      return this.$http.get('fuentes.detalle.activos').then(response=>{
      	this.detalles = response.data
      	this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    // Obtener las campañas
    getCampanias(){
      this.cargar = true
      this.campanias  = []
      return this.$http.get('campanias.activos').then((response) => {
        // Llenamos la etapa incial
        this.campanias = response.data
        this.campania  = this.campanias[0]
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    // obtener las vendedoras
    getVendedoras() {
      this.cargar = true
      this.vendedoras  = []
      return this.$http.get('vendedoras.list.twilio').then((response) => {
        // Llenamos la etapa incial
        this.vendedoras = response.data
        this.vendedoras_plantel = this.vendedoras.filter(el=> { return el.escuela == this.escuela})

        this.vendedoras_plantel.push({idplantel: 0, plantel:'SIN PLANTEL', nombre:'NA', nombre_plantel: 'SIN PLANTEL'})
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getVendedoras2() {
      this.cargar = true
      this.vendedorasAll  = []
      return this.$http.get('vendedoras.list.twilio.activas').then((response) => {
        // Llenamos la etapa incial
        this.vendedorasAll = response.data.filter( el => el.activo_sn )
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    /****************************/
    /****   	FUNCIONES      ****/
    /****************************/

    // Validamos los datos esten correctos
    grabarProspecto() {
      this.cargar = true

      if(this.prospecto.telefono < 1000000000){
        this.cargar = false
        this.validarErrorDirecto('El teléfono debe contar con 10 caracteres')
        return
      }

      this.cargar = true 

      if(this.prospecto.telefono == ''){
        return this.validarErrorDirecto('Favor de llenar el teléfono')
      }

      if(this.prospecto.nota_inicial == ''){
        return this.validarErrorDirecto('Favor de llenar la nota inicial')
      }

      // Sacamos a la vendedora
      let vendedora = 0

      if(this.prospecto.sucursal.idplantel != 0){
        vendedora = this.vendedoras_plantel.find(el=> el.idplantel == this.prospecto.sucursal.idplantel)
      }
      //recibe los campos del form
      //guardo en una variable los datos a guardar id = this.prospecto.idcurso;
      var payload = {
        nombre_completo:  this.prospecto.nombre_completo,
        telefono:         this.prospecto.telefono,
        correo:           this.prospecto.email,
        sucursal_interes: this.prospecto.sucursal.idplantel ? this.prospecto.sucursal.idplantel : 0,
        usuario_creo:     this.getdatosUsuarioERPERP.iderp,
        usuario_asignado: vendedora ? vendedora.iderp : 0,
        nota_inicial:     this.prospecto.nota_inicial,
        folio:            '',
        acronimo:         this.prospecto.sucursal.idplantel == 0 ? '' : this.prospecto.sucursal.acronimo,
        escuela:          this.escuela,
        idpuesto:         this.getdatosUsuarioERPERP.idpuesto,
        como_llego:       this.getdatosUsuarioERPERP.idpuesto == 25 ? this.campania.idcampanias : 0,
        idleds:           this.prospecto.idleds
      }

      this.cargar = false


      this.cargar = true
      this.$http.post('prospectos.add', payload).then(response  => {
        this.cargar = false
        this.dialogValidarEscuela = false
        this.dialogNuevoProspecto = false
        this.dialogValidarEscuela = false
        this.prospecto = {
          idprospectos     : 0,
          nombre_completo  : '',
          telefono         : '',
          correo           : '',
          idetapa          : 0,
          sucursal_interes : 0,
          como_nos_conocio : 0,
          ciclo_interes    : 0,
          curso_interes    : 0,
          usuario_asignado : 0,
          usuario_creo     : 0,
          nota_inicial     : '',
          folio            : ''
        }

        this.sucursal  = null
        this.anuncio   = null
        this.vendedora = null
        this.dialogSuccess = true
        this.getContactosAsignados()
        this.initialize();
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })

    },

    getCursosEscuela() {
      this.cargar = true
      this.cursos_escuela  = []
      return this.$http.get('escuela.cursos.activos').then((response) => {
        // Llenamos la etapa incial
        this.cursos_escuela = response.data.filter( el=> { return el.escuela == this.escuela })
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    preLlenarDatos ( item ) {
    	this.prospecto.nombre_completo = item.nombre_completo
    	this.prospecto.idleds          = item.idleds
    	this.dialogNuevoProspecto      = true
    },
    
    checkRespondio(item){
      this.$http.put('leds.update.respondio', item).then(response=>{
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },
    
    // La escuela y datos fueron validados, hay que grabar al prospecto
		escuelaValidada(){
      // Sacamos a la vendedora
      let vendedora = 0
      if(this.prospecto.sucursal.idplantel != 0){
        vendedora = this.vendedoras_plantel.find(el=> el.idplantel == this.prospecto.sucursal.idplantel)
      }
      //recibe los campos del form
      //guardo en una variable los datos a guardar id = this.prospecto.idcurso;
      var payload = {
        nombre_completo:  this.prospecto.nombre_completo,
        telefono:         this.prospecto.telefono,
        correo:           this.prospecto.email,
        sucursal_interes: this.editedItem.sucursal.idplantel ? this.editedItem.sucursal.idplantel : 0,
        usuario_creo:     this.getdatosUsuarioERPERP.iderp,
        usuario_asignado: vendedora ? vendedora.iderp : 0,
        nota_inicial:     this.prospecto.nota_inicial,
        folio:            '',
        acronimo:         this.prospecto.sucursal.idplantel == 0 ? '' : this.prospecto.sucursal.acronimo,
        escuela:          this.escuela,
        idpuesto:         this.getdatosUsuarioERPERP.idpuesto,
        como_llego:       this.getdatosUsuarioERPERP.idpuesto == 25 ? this.campania.idcampanias : 0,
        idleds:           this.prospecto.idleds
      }

      this.cargar = true
      this.$http.post('prospectos.add', payload).then(response  => {
        this.cargar = false
        this.dialogValidarEscuela = false
        this.dialogNuevoProspecto = false
        this.dialogValidarEscuela = false
        this.prospecto = {
          idprospectos     : 0,
          nombre_completo  : '',
          telefono         : '',
          correo           : '',
          idetapa          : 0,
          sucursal_interes : 0,
          como_nos_conocio : 0,
          ciclo_interes    : 0,
          curso_interes    : 0,
          usuario_asignado : 0,
          usuario_creo     : 0,
          nota_inicial     : '',
          folio            : ''
        }

        this.sucursal  = null
        this.anuncio   = null
        this.vendedora = null
        this.dialogSuccess = true
        this.getContactosAsignados()
        this.initialize();
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    async addContacto(lead, idleds) {
      console.log('SUBIR CONTACTO')
      // Sacamos sucursal y vendedora de forma segura
      const sucursal = this.editedItem && this.editedItem.sucursal ? this.editedItem.sucursal : null;

      let vendedoraId = 0;
      if (sucursal && sucursal.idplantel !== 0) {
        vendedoraId = sucursal.iderp || 0;
      }

      // Armamos payload con validaciones defensivas
      const payload = {
        nombre_completo:  lead.nombre_completo,
        telefono:         lead.telefono,
        correo:           lead.email,
        sucursal_interes: sucursal && sucursal.idplantel ? sucursal.idplantel : 0,
        sucursal_interes_2: this.editedItem.id_sucursal_interes || 0,
        curso_interes:      this.editedItem.curso_interes || null,
        horario_interes:    this.editedItem.horario_interes || null,
        usuario_creo:       this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.iderp : 0,
        usuario_asignado:   vendedoraId,
        nota_inicial:       lead.nota_inicial || '',
        folio:              '',
        acronimo:           sucursal && sucursal.idplantel !== 0 ? (sucursal.acronimo || '') : '',
        escuela:            this.escuela || '',
        idpuesto:           this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.idpuesto : 0,
        como_llego:         (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto === 25 && this.campania)
                              ? this.campania.idcampanias
                              : 0,
        idleds:             idleds
      };

      this.cargar = true;

      try {
        await this.$http.post('twilio.marketing.add.prospecto', payload);

        // Reset de formulario
        this.editedItem          = Object.assign({}, this.defaultItem);
        this.editedItem.sucursal = null;
        this.anuncio             = null;
        this.vendedora           = null;

        this.validarSuccess('Contacto generado correctamente');
        // this.close();
        // this.getContactosAsignados();
        // this.initialize();

      } catch (error) {
        console.error(error);

        this.validarError(msg);

      } finally {
        this.cargar = false;
      }
    },

    eliminarLead( idleds ){
      this.$http.delete('leds.delete/' + idleds ).then(response  => {
        this.getContactosAsignados()
        this.initialize();
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

		async save(item) {
      if (!this.editedItem.idfuentes) {
        this.validarErrorDirecto('Favor de llenar el campo: Origen');
        return;
      }

      this.editedItem.nombre_completo = this.editedItem.nombre_completo || 'Pendiente';
      this.editedItem.idmedio_contacto = 0;
      this.editedItem.iddetalle_fuentes = 0;
      this.editedItem.idcampanias = 0;
      this.editedItem.idcursos_escuela = this.editedItem.idcursos_escuela || this.editedItem.curso_interes || 0;
      this.editedItem.usuario_creo = this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.iderp : 0;
      this.editedItem.idpuesto = this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.idpuesto : 0;
      this.editedItem.como_llego = (this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto === 25 && this.campania)
        ? this.campania.idcampanias
        : 0;
      this.editedItem.escuela = this.escuela;

      this.cargar = true;

      try {
        const telefono = String(this.editedItem.telefono || '').trim();
        const endpoint = telefono.length >= 10 ? 'leds.add.marketing' : 'leds.add';
        const { data } = await this.$http.post(endpoint, this.editedItem);

        if (data.blocked) {
          this.validarError(data.message || 'El usuario ya existe.');
          return;
        }

        if (data.recurrencia) {
          const msg = data.actualizado
            ? (data.message || 'Lead y prospecto actualizados por recurrencia.')
            : (data.message || 'Lead registrado por recurrencia.');
          this.validarSuccess(msg);
          this.close();
          this.getContactosAsignados();
          this.initialize();
          return;
        }

        if (telefono && !data.omitirContacto) {
          await this.addContacto(this.editedItem, data.id);
          this.validarSuccess('Lead y contacto agregados correctamente');
        } else {
          this.validarSuccess(data.message || 'Lead agregado correctamente');
        }

        this.close();
        this.getContactosAsignados();
        this.initialize();

      } catch (error) {
        console.error(error);
        const data = error && error.response && error.response.data;
        const msg = (data && data.message) || 'Ocurrió un error al guardar el lead. Intente de nuevo.';

        if (data && data.blocked) {
          this.validarError(msg);
          return;
        }

        this.validarError(msg);
      } finally {
        this.cargar = false;
      }
    },

    deleteItemConfirm () {
      // Lo mandapos por el EP
      this.editedItem.deleted = 1
      this.cargar = true
      this.$http.put('fuentes.update/' + this.editedItem.idfuentes, this.editedItem).then(response=>{
      	this.dialogSuccess = true
      	this.cargar = false
      	this.closeDelete()
        this.getContactosAsignados()
      	this.initialize()
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    buscarTelefono( value ){
      if( value ||  this.searchTelefono){
        this.cargar = true

        const payload = {
          telefono: value ? value : this.searchTelefono,
          escuela: this.escuela
        }

        this.$http.post('leds.telefono', payload).then( response => {
          this.validarSuccess( response.data.message )
        }).catch( error => {
          this.cargar = false
          this.dialog = true
        }).finally( ()=> { this.cargar = false })
      }
    },

    editarLead( value ){
      this.editedItem    = Object.assign({}, value)
      this.dialogEditar  = true
    },

    actualizarLead( ){
      // Ponerle pendiente a su nombre completo
      if(this.editedItem.nombre_completo == ''){ this.editedItem.nombre_completo = 'Pendiente' }

      // Activamos el loader
      this.cargar = true
      // Lo mandapos por el EP
      this.$http.put('leds.update', this.editedItem).then(response=>{
        this.validarSuccess( 'Lead actualizado correctamente ')
        this.cerrarActualizar()
        this.getContactosAsignados()
        this.initialize()
        this.cargar      = false
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })

    },

    cerrarActualizar( ){
      this.editedItem    = Object.assign({}, this.defaultItem)
      this.dialogEditar  = false
    }


  }
}